import { newHttp } from "./request.js";
export function getCurrencyList(params) {
    return newHttp.get('/api/base-biz-data-server/query/data/currency/search', {
        params: params
    })
}